import React, { useEffect, useState, useRef } from "react";
import { get } from "lodash";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import MultiSelect from "multiselect-react-dropdown";
import { Select } from "antd";

function UpdatePortal(props) {
  const navigate = useHistory();
  const [formData, setName] = useState({
    portalName: "",
    ukey: "",
    gptkey: "",
    conapi: "",
    secapi: "",
    baseUrl: "",
    scenarioBaseUrl: "",
    custBgLimit: "",
    casesLimitPerInterval: "",
    casesLimitInterval: "",
    casesRemaining: "",
    casesLimitStartDate: "",
    custBgRemaining: "",
    survey_text: "",
    system_promt: "",
    cases_promt: "",
    blacklisted_keywords: [],
  });
  const [ShowLegacyCases, setShowLegacyCases] = useState(true);
  const portalId = localStorage.getItem("PortalId");
  const [SelectedList, setSelectedList] = useState([]);
  const [EnvSelectedList, setEnvSelectedList] = useState([]);
  const [ScenarioEnvSelectedList, setScenarioEnvSelectedList] = useState([]);
  const [CharacterSelectedList, setCharacterSelectedList] = useState([]);
  const [UserList, setUserList] = useState([]);
  const [EnvironmentList, setEnvironmentList] = useState([]);
  const [ScenarioEnvList, setScenarioEnvList] = useState([]);
  const [CharacterList, setCharacterList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [envSelectedOptions, setEnvSelectedOptions] = useState([]);
  const [scenarioEnvSelectedOptions, setScenarioEnvSelectedOptions] = useState([]);
  const [characterSelectedOptions, setCharacterSelectedOptions] = useState([]);
  const [Colr1, setColr1] = useState("");
  const [Colr2, setColr2] = useState("");
  const [Colr3, setColr3] = useState("");
  const [environmentImg, setEnvironmentImg] = useState("");
  const [scenarioEnvImg, setScenarioEnvImg] = useState("");
  const [characterImg, setCharacterImg] = useState("");

  const colorPickerRef1 = useRef();
  const colorPickerRef2 = useRef();
  const colorPickerRef3 = useRef();

  const portalid = portalId;

  // const userid = 1;

  const imagepath =
    `${process.env.REACT_APP_API_URL}/GetPortalImageById?PortId=` + portalid;

  // Code for filtered_keywords START
  const [concatenatedValues, setConcatenatedValues] = useState("");
  const [inputFields, setInputFields] = useState([]); // Initial state with one key-value pair

  const handleInputChange = (index, event, keyOrValue) => {
    const values = [...inputFields];
    values[index][keyOrValue] = event.target.value;
    setInputFields(values);
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, { key: '', value: '' }]);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };
  // Code for filtered_keywords END


  useEffect(() => {
    LoadPortals();
    LoadUsers();
    LoadUsersByportal();
    LoadEnvironmentsByportal();
    LoadScenarioEnvsByportal();
    LoadCharactersByportal();
    LoadEnvironments();
    LoadScenarioEnvs();
    LoadCharacters();

    if (concatenatedValues) {
      const valuesArray = concatenatedValues.split(', ');
      const parsedInputFields = valuesArray.map((pair) => {
        const [key, value] = pair.split(':');
        return { key, value };
      });
      setInputFields(parsedInputFields);
    }
  }, [concatenatedValues]);

  const LoadPortals = () => {
    const datavalue = {
      Portid: portalId,
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getPortalById`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        let data = {
          portalName: res.data[0].portal_Name,
          ukey: res.data[0].unique_KEY,
          gptkey: res.data[0].chat_gpt_KEY,
          conapi: res.data[0].congnitive_API,
          secapi: res.data[0].security_API,
          baseUrl: res.data[0].base_Url,
          scenarioBaseUrl: res.data[0].scenario_Base_Url,
          custBgRemaining: res.data[0].custom_Bg_Remaining,
          custBgLimit: res.data[0].custom_Bg_Limit,
          casesLimitPerInterval: res.data[0].cases_Limit_Per_Interval,
          casesRemaining: res.data[0].cases_Remaining,
          casesLimitInterval: res.data[0].cases_Limit_Interval,
          casesLimitStartDate: res.data[0].cases_Limit_Start_Date,
          survey_text: res.data[0].survey_text,
          system_promt: res.data[0].system_promt,
          cases_promt: res.data[0].cases_Promt,
          blacklisted_keywords:
            res.data[0].blacklisted_keywords !== "" &&
              res.data[0].blacklisted_keywords
              ? res.data[0].blacklisted_keywords.split(",")
              : [],
        };
        setShowLegacyCases(res.data[0].show_Legacy_Cases);
        setName(data);
        setColr1(res.data[0].sidebar_Color);
        setColr2(res.data[0].brand_Color);
        setColr3(res.data[0].header_Color);
        setConcatenatedValues(res.data[0].filtered_keywords);
      });
  };

  const LoadUsers = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GetFilerUserByUserPortal`)
      .then((res) => {
        //console.log("list", res.data)
        setUserList(res.data);
      });
  };

  const LoadEnvironments = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GeFiltertEnvironmentByUserPortal`)
      .then((res) => {
        //console.log("list", res.data)
        setEnvironmentList(res.data);
      });
  };

  const LoadScenarioEnvs = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GetFiltertScenarioEnvByUserPortal`)
      .then((res) => {
        setScenarioEnvList(res.data);
      });
  };

  const LoadCharacters = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GeFiltertCharacterByUserPortal`)
      .then((res) => {
        //console.log("list", res.data)
        setCharacterList(res.data);
      });
  };

  const onSelectColor1 = () => {
    const color = colorPickerRef1.current.value;
    setColr1(color);
    // console.log('selected color1', color);
  };
  const onSelectColor2 = () => {
    const color = colorPickerRef2.current.value;
    setColr2(color);
    // console.log('selected color22', color);
  };
  const onSelectColor3 = () => {
    const color = colorPickerRef3.current.value;
    setColr3(color);
    // console.log('selected color33', color);
  };

  const LoadUsersByportal = () => {
    const datavalue = {
      poid: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllUserByPortalId`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("Filter list", res.data)
      setSelectedOptions(res.data);
      setSelectedList(res.data);
      // setSelectedOptions.map(
      //         option => option.find(o => o.ID === option.UID))
    });
  };

  const LoadEnvironmentsByportal = () => {
    const datavalue = {
      id: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllEnvironmentByPortalId`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      setEnvSelectedOptions(res.data);
      setEnvSelectedList(res.data);
    });
  };

  const LoadScenarioEnvsByportal = () => {
    const datavalue = {
      id: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllScenarioEnvByPortalId`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      setScenarioEnvSelectedOptions(res.data);
      setScenarioEnvSelectedList(res.data);
    });
  };

  const LoadCharactersByportal = () => {
    const datavalue = {
      id: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllCharacterByPortalId`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      setCharacterSelectedOptions(res.data);
      setCharacterSelectedList(res.data);
    });
  };


  const onSelect = (selectedList, selectedItem) => {
    //console.log(selectedList);
    setSelectedList(selectedList);
    //console.log('The selected data', selectedList);
  };

  const onEnvSelect = (envSelectedList, envSelectedItem) => {
    setEnvSelectedList(envSelectedList);
    var imagepath = `${process.env.REACT_APP_API_URL}/GetEnvironmentImageById?EnvironmentId=` + envSelectedItem.id;
    setEnvironmentImg(imagepath);
  };

  const onScenarioEnvSelect = (envSelectedList, envSelectedItem) => {
    setScenarioEnvSelectedList(envSelectedList);
    var imagepath = `${process.env.REACT_APP_API_URL}/GetScenarioEnvImageById?EnvironmentId=` + envSelectedItem.id;
    setScenarioEnvImg(imagepath);
  };

  const onCharacterSelect = (characterSelectedList, characterSelectedItem) => {
    //console.log(selectedList);
    setCharacterSelectedList(characterSelectedList);
    var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + characterSelectedItem.id;
    setCharacterImg(imagepath);
  };

  const updateBlacklistText = (e) => {
    setName({ ...formData, blacklisted_keywords: e });
  };

  const onRemove = (selectedList, removedItem) => {
    //console.log('The onRemove data', removedItem.uid);

    const datavalue = {
      DPid: portalId,
      UDid: removedItem.uid,
    };
    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeletePortalManager`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      // axios.post(`https://localhost:7261/DeleteIntents`, datavalue, config)
      .then((res) => {
        //console.log("get value", res);

        //console.log("success")

        // setName({ intents: "", Ans1: "", Ans2: "" });
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          // window.location.href = "/patient-ai/IntentList";
          // history.push('/patient-ai/IntentList');
          // navigate.push('/PatientList');
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };

  const onEnvRemove = (envSelectedList, envRemovedItem) => {
    const datavalue = {
      DPid: portalId,
      UEid: envRemovedItem.id,
    };
    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeletePortalEnvironment`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      .then((res) => {
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };

  const onScenarioEnvRemove = (envSelectedList, envRemovedItem) => {
    const datavalue = {
      DPid: portalId,
      UEid: envRemovedItem.id,
    };
    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeletePortalScenarioEnv`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      .then((res) => {
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };

  const onCharacterRemove = (characterSelectedList, characterRemovedItem) => {
    const datavalue = {
      DPid: portalId,
      UCid: characterRemovedItem.id,
    };
    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeletePortalCharacter`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      .then((res) => {
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };

  const PortalSubmit = async (e) => {
    e.preventDefault();

    if (inputFields.some(field => field.key === '')) {
      Swal.fire({
        title: "Error",
        text: "Key can not be empty",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    const filterable_texts = inputFields.map(({ key, value }) => `${key}:${value}`).join(', ');

    //console.log("formData", formData)

    let formDataSet = new FormData();
    //formdata object
    if (
      formData.portalName === "" ||
      formData.secapi === "" ||
      formData.baseUrl === "" ||
      formData.system_promt === "" ||
      formData.cases_promt === "" ||
      formData.scenarioBaseUrl === "" ||
      formData.custBgLimit === "" ||
      formData.casesLimitPerInterval === "" ||
      formData.casesLimitInterval === "" ||
      formData.casesLimitStartDate === "" ||
      EnvSelectedList.length === 0 ||
      CharacterSelectedList.length === 0
    ) {
      if (formData.portalName === "") {
        Swal.fire({
          title: "Error",
          text: "Portal Name Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.system_promt === "") {
        Swal.fire({
          title: "Error",
          text: "System Prompt Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.cases_promt === "") {
        Swal.fire({
          title: "Error",
          text: "Cases Prompt Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.secapi === "") {
        Swal.fire({
          title: "Error",
          text: "Security Key Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.baseUrl === "") {
        Swal.fire({
          title: "Error",
          text: "Base URL is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.scenarioBaseUrl === "") {
        Swal.fire({
          title: "Error",
          text: "Scenario Base URL is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.custBgLimit === "") {
        Swal.fire({
          title: "Error",
          text: "Limit is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.casesLimitPerInterval === "") {
        Swal.fire({
          title: "Error",
          text: "Cases Limit Per interval is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.casesLimitInterval === "") {
        Swal.fire({
          title: "Error",
          text: "Cases Limit Interval is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.casesLimitStartDate === "") {
        Swal.fire({
          title: "Error",
          text: "Cases Limit Start Date is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (EnvSelectedList.length === 0) {
        Swal.fire({
          title: "Error",
          text: "Please select at least one Environment",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (CharacterSelectedList.length === 0) {
        Swal.fire({
          title: "Error",
          text: "Please select at least one Character",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } else {
      const datavalue = {
        Id: portalId,
        Portal_Name: formData.portalName,
        Unique_KEY: formData.ukey,
        Chat_gpt_KEY: formData.gptkey,
        Congnitive_API: formData.conapi,
        Security_API: formData.secapi,
        Base_Url: formData.baseUrl,
        Scenario_Base_Url: formData.scenarioBaseUrl,
        Custom_Bg_Limit: formData.custBgLimit,
        Cases_Limit_Per_Interval: formData.casesLimitPerInterval,
        Cases_Limit_Interval: formData.casesLimitInterval,
        Cases_Limit_Start_Date: formData.casesLimitStartDate,
        sidebar_Color: Colr1,
        brand_Color: Colr2,
        header_Color: Colr3,
        UserProfiles: SelectedList,
        Environments: EnvSelectedList,
        Scenario_Environments: ScenarioEnvSelectedList,
        Characters: CharacterSelectedList,
        survey_text: formData.survey_text,
        system_promt: formData.system_promt,
        Cases_Promt: formData.cases_promt,
        blacklisted_keywords: formData.blacklisted_keywords.join(","),
        Show_Legacy_Cases: ShowLegacyCases,
        filtered_keywords: filterable_texts,
      };

      // Extract token from localStorage.state
      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/updatePortalByid`,
        data: datavalue,
        headers: { "Content-Type": "application/json", ...(token && { "Authorization": `Bearer ${token}` }) },
      };
      axios(authOptions)
        .then((res) => {
          if (res.data.ExpResult) {
            Swal.fire({
              title: "Failed",
              text: res.data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
            });
          } else if (res.data.SuccessResult) {
            Swal.fire({
              title: "Success",
              text: res.data.SuccessResult,
              icon: "success",
              confirmButtonText: "Ok",
            }).then(function () {
              window.location.reload(true);
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "An error occured!",
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };
  const onUpload = (event) => {
    const imagevalue = {
      formFile: get(event, "target.files[0]"),
      PtalId: portalId,
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/UploadPortalImageByID`,
      data: imagevalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("save msg", res)
      // window.location.reload(true)
      // navigate.push('/');
    });
  };

  const BackFunc = () => {
    // UserRole === "Admin" ?  navigate.push('/ManagerList'): navigate.push('/index')
    navigate.push("/PortalList");
  };

  const handleChange = (e) => {
    console.log(e.target.name, e.target.value);
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  function handleChangeShowLegacyCases(e) {
    setShowLegacyCases(e.target.checked);
  }

  // console.log(formData);
  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Update Portal</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">

            <div className="col-md-12 col-sm-12">
              <div className="card card-box">
                <div className="card-head">
                  <header>Profile</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  {/* <form className="form-horizontal"> */}
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={PortalSubmit}
                  >
                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Potal Name
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.portalName}
                            onChange={(e) => handleChange(e)}
                            name="portalName"
                            className="form-control"
                            id="ans1"
                            placeholder="Portal Name"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group">
                            <label
                              for="simpleFormPassword"
                              className="control-label"
                            >
                              ChatGPT
                            </label>
                            <input
                              type="text"
                              value={formData.gptkey}
                              onChange={(e) => handleChange(e)}
                              name="gptkey"
                              className="form-control"
                              id="ans2"
                              placeholder="ChatGPT"
                            />
                          </div>
                        </div>
                        {/* <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Unique Key
                          </label>
                          <input
                            type="text"
                            value={formData.ukey}
                            onChange={handleChange}
                            name="ukey"
                            className="form-control"
                            id="ans1"
                            placeholder="Unique Key"
                          />
                        </div> */}
                      </div>
                    </div>

                    {/* Scenario Base URL and Case Base URL */}
                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="baseUrl"
                            className="control-label"
                          >
                            Base URL
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.baseUrl}
                            onChange={(e) => handleChange(e)}
                            name="baseUrl"
                            className="form-control"
                            id="baseUrl"
                            placeholder="Base URL"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="scenarioBaseUrl"
                            className="control-label"
                          >
                            Scenario Base URL
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.scenarioBaseUrl}
                            onChange={(e) => handleChange(e)}
                            name="scenarioBaseUrl"
                            className="form-control"
                            id="scenarioBaseUrl"
                            placeholder="Scenario Base URL"
                          />
                        </div>
                      </div>
                    </div>


                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="custBgLimit"
                            className="control-label"
                          >
                            Image Generation Limit
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            value={formData.custBgLimit}
                            onChange={handleChange}
                            name="custBgLimit"
                            className="form-control"
                            id="custBgLimit"
                            placeholder="0"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="custBgRemaining"
                            className="control-label"
                          >
                            Image Generation Remaining
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            value={formData.custBgRemaining}
                            //onChange={handleChange}
                            name="custBgRemaining"
                            className="form-control"
                            id="custBgRemaining"
                            disabled={true}
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>


                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="casesLimitPerInterval"
                            className="control-label"
                          >
                            Cases Limit (per interval)
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            min={0}
                            value={formData.casesLimitPerInterval}
                            onChange={handleChange}
                            name="casesLimitPerInterval"
                            className="form-control"
                            id="casesLimitPerInterval"
                            placeholder="0"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="casesRemaining"
                            className="control-label"
                          >
                            Cases Remaining
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            value={formData.casesRemaining}
                            name="casesRemaining"
                            className="form-control"
                            id="casesRemaining"
                            disabled={true}
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>


                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="casesLimitInterval"
                            className="control-label"
                          >
                            Cases Limit Interval (in days)
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            min={0}
                            value={formData.casesLimitInterval}
                            onChange={handleChange}
                            name="casesLimitInterval"
                            className="form-control"
                            id="casesLimitInterval"
                            placeholder="0"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="casesLimitStartDate"
                            className="control-label"
                          >
                            Cases Limit Start Date
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="date"
                            value={formData.casesLimitStartDate}
                            onChange={handleChange}
                            name="casesLimitStartDate"
                            className="form-control"
                            id="casesLimitStartDate"
                          />
                        </div>
                      </div>
                    </div>


                    <div className="form-group">
                      <div className="row">
                        {/* <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Conginitive API
                          </label>
                          <input
                            type="text"
                            value={formData.conapi}
                            onChange={handleChange}
                            name="conapi"
                            className="form-control"
                            id="ans2"
                            placeholder="Conginitive API"
                          />
                        </div> */}
                        <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Security API
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.secapi}
                            onChange={(e) => handleChange(e)}
                            name="secapi"
                            className="form-control"
                            id="ans2"
                            placeholder="Security API"
                          />
                        </div>

                        {/* <div className="col-12 col-md-6">
                          <label
                            for="baseUrl"
                            className="control-label"
                          >
                            Base URL
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.baseUrl}
                            onChange={(e) => handleChange(e)}
                            name="baseUrl"
                            className="form-control"
                            id="baseUrl"
                            placeholder="Base URL"
                          />
                        </div> */}
                      </div>
                    </div>

                    <div className="form-group">
                      {/* <div className="card-body " id="bar-parent10"> */}
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="col-lg-3 col-md-4 control-label">
                            Manager List
                          </label>
                          <MultiSelect
                            options={UserList}
                            onSelect={onSelect}
                            onRemove={onRemove}
                            selectedValues={selectedOptions}
                            displayValue="first_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <div className="col-2">
                            <img
                              src={imagepath}
                              style={{
                                width: "200px",
                                maxHeight: "50px",
                                objectFit: "contain",
                              }}
                              alt="new"
                            />
                          </div>
                          <div className="col-10">
                            <div
                              className="photoEdit mt-3"
                              style={{ position: "relative" }}
                            >
                              <input
                                type="file"
                                onChange={onUpload}
                                id="myFile"
                                name="formFile"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                    </div>

                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-4 col-sm-4">
                          <label class="control-label">Sidebar Color</label>
                          <div class="input-group col-md-8">
                            <input
                              //   id="cp1"
                              type="color"
                              className="form-control"
                              name="colo1"
                              value={Colr1}
                              ref={colorPickerRef1}
                              onChange={() => onSelectColor1()}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                          <label class="control-label">
                            Header Brand color
                          </label>
                          <div class="input-group col-md-8">
                            <input
                              type="color"
                              className="form-control"
                              name="colo2"
                              value={Colr2}
                              ref={colorPickerRef2}
                              onChange={() => onSelectColor2()}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                          <label class="control-label">Header color</label>
                          <div class="input-group col-md-8">
                            <input
                              type="color"
                              className="form-control"
                              name="colo3"
                              value={Colr3}
                              ref={colorPickerRef3}
                              onChange={() => onSelectColor3()}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-12 col-sm-12">
                          <label class="control-label">System Prompt</label>
                          <textarea
                            className="form-control"
                            name="system_promt"
                            style={{ width: "100%", height: "100px" }}
                            value={formData.system_promt}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-12 col-sm-12">
                          <label class="control-label">Cases Prompt</label>
                          <textarea
                            className="form-control"
                            name="cases_promt"
                            style={{ width: "100%", height: "100px" }}
                            value={formData.cases_promt}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="col-lg-6 col-md-6 control-label">
                            Blacklisted Keywords
                          </label>
                          <Select
                            mode="tags"
                            style={{ width: "100%" }}
                            placeholder="Tags Mode"
                            name="blacklisted_keywords"
                            onChange={(e) => updateBlacklistText(e)}
                            value={formData.blacklisted_keywords.map((item) => {
                              return {
                                value: item,
                                label: item,
                              };
                            })}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label class="control-label">Filter Keywords</label>

                      {inputFields.map((field, index) => (
                        <div key={index}>

                          <div class="form-group row">
                            <div className="col-md-6 col-sm-6">
                              <div className="form-group row">
                                <div className="col-md-5 col-sm-5">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Key"
                                    value={field.key}
                                    onChange={(event) => handleInputChange(index, event, 'key')}
                                  />
                                </div>
                                <div className="col-md-5 col-sm-5">
                                  <input
                                    type="text"
                                    placeholder="Value"
                                    className="form-control"
                                    value={field.value}
                                    onChange={(event) => handleInputChange(index, event, 'value')}
                                  />
                                </div>
                                <div className="col-md-2 col-sm-2">
                                  <button type="button" className="btn btn-danger" onClick={() => handleRemoveFields(index)}>
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="form-group row">
                        <div className="col-md-5 col-sm-5 d-flex justify-content-center">
                          <button type="button" className="btn btn-success" onClick={handleAddFields}>
                            Add
                          </button>
                        </div>
                      </div>

                    </div>

                    <div className="form-group">
                      {/* <div className="card-body " id="bar-parent10"> */}
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="control-label">
                            Environment List
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <MultiSelect
                            options={EnvironmentList}
                            onSelect={onEnvSelect}
                            onRemove={onEnvRemove}
                            selectedValues={envSelectedOptions}
                            displayValue="environment_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6 d-flex justify-content-center align-items-center">
                          <a href={environmentImg} target="_blank" rel="noopener">
                            <img
                              src={environmentImg}
                              style={{
                                width: "150px",
                                maxHeight: "150px",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="control-label">
                            Multi-Char Environment List
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <MultiSelect
                            options={ScenarioEnvList}
                            onSelect={onScenarioEnvSelect}
                            onRemove={onScenarioEnvRemove}
                            selectedValues={scenarioEnvSelectedOptions}
                            displayValue="environment_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6 d-flex justify-content-center align-items-center">
                          <a href={scenarioEnvImg} target="_blank" rel="noopener">
                            <img
                              src={scenarioEnvImg}
                              style={{
                                width: "150px",
                                maxHeight: "150px",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      {/* <div className="card-body " id="bar-parent10"> */}
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="control-label">
                            Character List
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <MultiSelect
                            options={CharacterList}
                            onSelect={onCharacterSelect}
                            onRemove={onCharacterRemove}
                            selectedValues={characterSelectedOptions}
                            displayValue="character_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6 d-flex justify-content-center align-items-center">
                          <a href={characterImg} target="_blank" rel="noopener">
                            <img
                              src={characterImg}
                              style={{
                                width: "150px",
                                maxHeight: "150px",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-12 col-sm-12">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={handleChangeShowLegacyCases} checked={ShowLegacyCases} />
                            <label class="form-check-label" for="flexCheckDefault">
                              Show Legacy cases
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-12 col-sm-12">
                          <label class="control-label">Survey Text</label>
                          <textarea
                            className="form-control"
                            name="survey_text"
                            style={{ width: "100%", height: "100px" }}
                            value={formData.survey_text}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}

                    <button
                      type="submit"
                      className="btn btn-primary m-r-20 d-inline-block"
                    >
                      Submit
                    </button>
                    {/* <button type="button" className="btn btn-default d-inline-block" onClick={canclebtn}>Cancel</button> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdatePortal;
